"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProject = void 0;
const getProject = ({ httpClient, }) => ({ project_id, }) => {
    const path = '/projects';
    const url = `${path}/${project_id}`;
    return httpClient.get(url);
};
exports.getProject = getProject;
//# sourceMappingURL=get-project.js.map